export default __webpack_public_path__ + "static/media/N_wdt_c_cap_0.17a4fc2a.mp3";